/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StruttureResDto } from '../../models/strutture-res-dto';

export interface StruttureControllerDeleteStruttura$Params {
  idStruttura: number;
}

export function struttureControllerDeleteStruttura(
  http: HttpClient,
  rootUrl: string,
  params: StruttureControllerDeleteStruttura$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<StruttureResDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    struttureControllerDeleteStruttura.PATH,
    'delete',
  );
  if (params) {
    rb.path('idStruttura', params.idStruttura, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<StruttureResDto>;
      }),
    );
}

struttureControllerDeleteStruttura.PATH = '/admin/strutture/id/{idStruttura}';
